module.exports = __webpack_public_path__ + "img/Chart-Bar-Stack-Color.7c238918.png";